import { render, staticRenderFns } from "./ParticipantAdmin.vue?vue&type=template&id=6583bc4b"
import script from "./ParticipantAdmin.vue?vue&type=script&lang=js"
export * from "./ParticipantAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports